// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import { routes } from 'app/constants';
import { MrAppLayout, MrHeaderTabs, MrTab, MrTabList, MrTabPanel } from '@ion/components';
import AppHeader from 'app/components/app-header';
import SideNav from 'app/components/side-nav';
import useCanViewEventDebugger from 'app/event-monitoring/event-debugger/useCanViewEventDebugger';
import EventDebuggerPage from './event-debugger';
import EventSchemasPage from './event-schemas';
import MrTabPanelBase from 'app/components/MrTabPanelBase';

export default function EventMonitoringPage() {
  const { canViewEventDebugger: showEventDebuggerTab } = useCanViewEventDebugger();

  return (
    <MrAppLayout
      title="Event Monitoring"
      header={<AppHeader icon="schemaReport" title="Event Monitoring" route={routes.eventMonitoring} />}
      sideNav={<SideNav />}
    >
      <MrHeaderTabs>
        <MrTabList>
          {showEventDebuggerTab && <MrTab>Event Debugger</MrTab>}
          <MrTab>Schema Report</MrTab>
        </MrTabList>
        {showEventDebuggerTab && (
          <MrTabPanel>
            <MrTabPanelBase>
              <EventDebuggerPage />
            </MrTabPanelBase>
          </MrTabPanel>
        )}
        <MrTabPanel>
          <EventSchemasPage />
        </MrTabPanel>
      </MrHeaderTabs>
    </MrAppLayout>
  );
}
